export const AddressService = {
  shorten: (address: string, start: number, end: number) => {
    return `${address.slice(undefined, start)}...${address.slice(-end)}`
  },
}
